<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="mb-24">
            <h2 class="u-text-normal mb-12">Login</h2>

            <form @submit.prevent="onSubmit">
                <div class="form-group mr-12">
                    <label for="username">E-Mail <sup>*</sup></label>
                    <input
                        v-model="form.username"
                        class="form-control"
                        id="username"
                        type="text"
                        autocomplete="username"
                        autofocus
                        required
                    />
                </div>

                <div class="form-group mr-12">
                    <label for="password">Passwort <sup>*</sup></label>
                    <input
                        v-model="form.password"
                        class="form-control"
                        id="password"
                        type="password"
                        autocomplete="password"
                        required
                    />
                </div>

                <app-button type="submit" :is-loading="isLoading">Login</app-button>
            </form>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/ui/Button.vue'

export default {
    name: 'Login',

    components: { AppButton },

    data () {
        return {
            isLoading: false,
            form: {
                username: '',
                password: '',
            },
        }
    },

    methods: {
        async onSubmit () {
            if (!this.formIsValid()) {
                this.$toast.open({ type: 'error', message: 'Diese Zugangsdaten sind ungültig.' })
                return
            }

            this.isLoading = true
            try {
                const response = await this.$http.post('/login_check', this.form, {
                    // API needs explicitly application/json
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                const token = response?.data?.token
                if (!token) {
                    throw new Error('Es ist ein Fehler aufgetreten.')
                }

                this.$store.commit('setAccessToken', token)
                await this.$router.push({ name: 'Home' })
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                this.isLoading = false
            }
        },

        formIsValid () {
            return !(!this.form.username || !this.form.password);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
